module.exports = __webpack_public_path__ + "img/partners9.2e677f18.jpg";